import { useState, useEffect } from 'react';
import { Modal, Table, Button } from 'semantic-ui-react';
import { useTable } from 'react-table';
import { getAPI } from '../../../libs/fetchAPI';
import TableStyles from '../../../components/table/TableStylesCompact';
import Duration from '../../../components/Duration';
import Loading from '../../../components/Loading';
import RightCell from '../../../components/table/RightCell';

function TestsModal({ open, suite_params, handleClose }) {
	const [ loading, setLoading ] = useState(false);
	const [ tests, setTests ]     = useState([]);

	useEffect(() => {
		if(suite_params) {
			setLoading(true);

			const params = {
				...suite_params,
				...{
					sort_key       : `spec_file`,
					sort_direction : `ASC`,
				}
			};

			getAPI(`/suite_info/tests?${new URLSearchParams(params)}`)
				.then(({ data }) => {
					setTests(data.reverse());
					setLoading(false);
				});
		}
	}, [suite_params]);

	const columns = [
		{
			Header   : `Title`,
			accessor : `title`,
		},
		{
			Header   : `Passes`,
			accessor : `passes`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Fails`,
			accessor : `fails`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Skipped`,
			accessor : `skips`,
			Cell     : ({ cell }) => <RightCell>{cell.value}</RightCell>
		},
		{
			Header   : `Avg Duration`,
			accessor : `average_duration`,
			Cell     : ({ cell }) => <RightCell><Duration duration={cell.value} /></RightCell>
		},
	];

	if(loading) {
		return <Loading />
	}

	return (
		<Modal
			size="large"
			closeIcon
			onClose={handleClose}
			open={open}
		>
			<Modal.Header>
				Suite Tests
			</Modal.Header>

			<Modal.Content>
				<ModalTable
					columns={columns}
					data={tests}
				/>
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleClose}>Close</Button>
			</Modal.Actions>
		</Modal>
	)
}

function ModalTable({ columns, data }) {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
	} = useTable({ columns, data });

	return (
		<TableStyles>
			<Table striped celled {...getTableProps()}>
				<thead>
					{headerGroups.map((headerGroup, i) => (
						<tr {...headerGroup.getHeaderGroupProps} key={i}>
							{headerGroup.headers.map(column => (
								<th {...column.getHeaderProps()}>{column.render('Header')}</th>
							))}
						</tr>
					))}
				</thead>

				<Table.Body {...getTableBodyProps()}>
					{rows.map((row, i) => {
						prepareRow(row)

						return (
							<tr {...row.getRowProps()} key={i}>
								{row.cells.map(cell => {
									return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
								})}
							</tr>
						)
					})}
				</Table.Body>
			</Table>
		</TableStyles>
	);
}

export default TestsModal;
